import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import Glyph from 'components/Glyph';
import MediaObject from 'components/MediaObject';
import MenuButton from 'components/MenuButtonDeprecated';
import Text from 'components/Text';
// @ts-ignore
import TextWithEntities from 'components/TextWithEntities';
import Time from 'components/Time';
import GroupAvatar from 'groups/components/GroupAvatar';
// @ts-ignore
import TextEntities from 'lib/TextEntities';

import { RosterGroupSummary } from './SetupRosterConfirm';

type Props = {
  group: RosterGroupSummary;
  menu: React.ReactElement;
};

export default class SetupConfirmClassesListItem extends React.Component<Props> {
  renderGroupName() {
    const groupName = this.props.group.className;
    const entities = TextEntities.parseEmoji(groupName);
    return <TextWithEntities text={groupName} entities={entities} />;
  }

  renderSubtext() {
    const { group } = this.props;

    return (
      <Text color="graphite" element="div" size="xxsmall">
        {group.code && `${group.code} • `}
        {'Created '}
        <Time date={new Date(group.createdAt)} month="numeric" day="numeric" year="numeric" />
      </Text>
    );
  }

  render() {
    const { group, menu } = this.props;

    return (
      <MediaObject center figure="right" gutter="xsmall" className="SetupConfirmClassesListItem">
        <MediaObject center>
          <GroupAvatar group={group} size="medium" />
          <div>
            <Text color="chalkboard" size="xsmall" weight="semibold">
              {this.renderGroupName()}
            </Text>
            {this.renderSubtext()}
          </div>
        </MediaObject>
        <Buttons>
          {group.kind === 'proposedGroup' && (
            <Button
              aria-label="New classes from your school database are added to your Remind account automatically"
              tooltip="New classes from your school database are added to your Remind account automatically"
              tooltipPlacement="top"
              color="atlas"
              weight="normal"
              level="icon">
              <Text size="xxxsmall" smallCaps weight="normal">
                NEW
              </Text>
            </Button>
          )}
          {group.hasRosterSource && (
            <Button
              className="SetupConfirmClassesListItem-link"
              aria-label="Linked Remind classes are updated directly from your school’s database"
              tooltip="Linked Remind classes are updated directly from your school’s database"
              tooltipPlacement="top"
              color="atlas"
              level="icon">
              <Glyph name="link" size="large" solo />
            </Button>
          )}
          <MenuButton
            className="SetupConfirmClassesListItem-menuButton"
            alignment="right"
            placement="bottom"
            menu={menu}
            size="small"
            level="icon">
            <Glyph name="ellipses" size="large" solo />
          </MenuButton>
        </Buttons>
      </MediaObject>
    );
  }
}
